function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeleteBin = function SvgDeleteBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24351"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17710",
    d: "m14.5 5.8-.607 8.5a1.4 1.4 0 0 1-1.4 1.3H6.7a1.4 1.4 0 0 1-1.4-1.3l-.6-8.5m3.5 2.8v4.2M11 8.6v4.2m.7-7V3.7A.7.7 0 0 0 11 3H8.2a.7.7 0 0 0-.7.7v2.1M4 5.8h11.2",
    transform: "translate(-.85 .15)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1919",
    d: "M18 18H0V0h18Z",
    transform: "rotate(-90 9 9)",
    style: {
      opacity: 0.87,
      fill: "none"
    }
  })));
};

export default SvgDeleteBin;